import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { performanceChartNavSelector } from 'store/modules/statspro/performance-chart/selectors/nav-selector';
import { useGetPlayerCareerSeasonStatsQuery } from 'common/store/modules/api/statsPro-api';
import { changeSeason } from 'common/store/modules/statspro/thunks/change-season';
import { performanceChartActions } from 'common/store/modules/statspro/performance-chart';

export const SeasonNavItem = ({ playerIds, isAFLW }) => {
    const dispatch = useDispatch();
    const nav = useSelector(performanceChartNavSelector);

    const { data: careerData } = useGetPlayerCareerSeasonStatsQuery(
        {
            isAFLW: isAFLW,
            playerId: playerIds[1]
        },
        { skip: playerIds[2] }
    );

    const seasonsList = nav?.seasons;

    const seasons = [
        { id: -1, name: getTranslation('label.stats.career') },
        ...(playerIds[2]
            ? seasonsList
            : seasonsList.filter((item) =>
                  careerData?.yearlySeasonStats.some(
                      (season) => season.seasonId === item.providerId
                  )
              ))
    ];

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                items={seasons}
                itemToString={(season) => season.name}
                icon="season-trophy"
                type="with-default"
                className="w-100"
                selectedItemToString={(item) => item?.name.split(' ')[0]}
                initialSelectedItem={
                    seasons.length && nav.season.id
                        ? seasons.find((s) => s.id === nav.season.id)
                        : ''
                }
                activeItem={
                    seasons.length && nav.season.id
                        ? seasons.find((s) => s.id === nav.season.id)
                        : ''
                }
                isReadyToRender={() => seasons?.length && nav.season.id}
                label={`${getTranslation(
                    'label.stats.career'
                )}/${getTranslation('label.stats.season')}`}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        changeSeason({
                            slice: 'performance-chart',
                            season: selectedItem
                        })
                    );

                    // set data tyoe to TOTALS if CAREER is selected
                    if (selectedItem.id === -1) {
                        dispatch(
                            performanceChartActions.setDataType({
                                type: 'totals'
                            })
                        );
                    }
                }}
            />
        </div>
    );
};

SeasonNavItem.propTypes = {
    isAFLW: PropTypes.bool,
    playerIds: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};
